import React from 'react'
import PropTypes from 'prop-types'
import ContactRow from './Row'

const List = ({ contacts, formatPhoneNumber, handleContactEdit }) => (
  <ul className="contactsList">
    {
      contacts && contacts.map(
        contact => (
          <ContactRow
            key={contact.id}
            formatPhoneNumber={formatPhoneNumber}
            handleContactEdit={handleContactEdit}
            {...contact}
          />
        ),
      )
    }
  </ul>
)

List.propTypes = {
  contacts: PropTypes.arrayOf(PropTypes.object).isRequired,
  formatPhoneNumber: PropTypes.func.isRequired,
  handleContactEdit: PropTypes.func.isRequired,
}

export default List



// WEBPACK FOOTER //
// ./src/components/CallLog/ContactsTab/List.js